module.exports = __webpack_public_path__ + "static/media/5.88008714.png";